<template>
  <div class="col-md-6 ml-auto mr-auto">
    <div style="position: fixed; inset-inline-start: 1em; min-width: 104px; z-index: 1" class="setting-icon">
      <i class="fa fa-cog" style="color: #eee; font-size: large" @click="$router.push('baseurl')"></i>
    </div>
    <div style="
        position: fixed;
        inset-inline-end: 0px;
        min-width: 104px;
        z-index: 1;
      " class="language-selection">
      <i class="fa fa-globe-asia" style="font-size: 1.2em; color: white"></i>
      <!-- if language not عربي set dropdown position to right-->
      <drop-down :position="$i18n.locale !== 'ar' ? 'right' : ''" tag="div" :title="getLocaleName()">
        <a class="dropdown-item" @click="selectLanguage('en-US')" v-if="isSupportedLanguage('en-US')">English</a>
        <a class="dropdown-item" @click="selectLanguage('hi')" v-if="isSupportedLanguage('hi')">हिन्दी</a>
        <a class="dropdown-item" @click="selectLanguage('el-GR')" v-if="isSupportedLanguage('el-GR')">Ελληνικά</a>
        <a class="dropdown-item" @click="selectLanguage('es-ES')" v-if="isSupportedLanguage('es-ES')">Español</a>
        <a class="dropdown-item" @click="selectLanguage('ru')" v-if="isSupportedLanguage('ru')">русский</a>
        <a class="dropdown-item" @click="selectLanguage('kn')" v-if="isSupportedLanguage('kn')">ಕನ್ನಡ</a>
        <a class="dropdown-item" @click="selectLanguage('ar')" v-if="isSupportedLanguage('ar')">عربي</a>
        <a class="dropdown-item" @click="selectLanguage('fr')" v-if="isSupportedLanguage('fr')">française</a>
      </drop-down>
    </div>

    <form @submit.prevent="signin()" class="vld-parent" ref="formContainer">
      <card class="card-login card-plain" style="margin-bottom:0;">
        <div slot="header">
          <div class="logo-container" style="margin-bottom:3em;">
            <img v-if="!brandLogoUrl && !appSettings.whiteLabelled" class="brand-logo" src="@/assets/img/carenation.png" alt />
            <div v-if="brandLogoUrl" style="text-align: center;">
              <img class="brand-logo" :src="brandLogoUrl" alt />
            </div>
            <!-- <span style="color:white; float: right; font-size: 1.5em;">Clinic</span> -->
          </div>
        </div>

        <div v-if="!IS_OTP_LOGIN">
          <fg-input class="no-border form-control-lg" :placeholder="$t('message.Username')" autocapitalize="none" id="username" addon-left-icon="now-ui-icons users_circle-08" v-model="username"></fg-input>

          <fg-input class="no-border form-control-lg" v-model="password" @focus="clearError()" type="password" :placeholder="$t('message.Password')" addon-left-icon="now-ui-icons objects_key-25"></fg-input>
        </div>
        <div v-if="IS_OTP_LOGIN">
          <tabs type="primary">
            <tab-pane label="mobile">
              <template slot="label">
                <div @click="setActiveTab('mobile')" style="display: flex;flex-direction: row;align-items: center;height: 2.5em;">
                  <i class="fas fa-mobile-alt" style="position: relative;inset-inline-start:15%;" />
                  <div class="ml-1" style="position: relative;inset-inline-start:15%;">{{ $t("message.Mobile") }}</div>
                </div>
              </template>
              <VuePhoneNumberInput style="direction: ltr;" v-model="mobileNumber" :dark="true" :no-example="true" :border-radius="25" default-country-code="IN" :preferred-countries="['IN']" @update="mobileNumberUpdate" />
              <div class="text-danger invalid-feedback mt-2" style="display: block" v-if="mobileNumber && !isValidMobile">
                {{ $t("message.Please enter valid mobile number") }}
              </div>
            </tab-pane>
            <tab-pane label="email">
              <template slot="label">
                <div @click="setActiveTab('email')" style="display: flex;flex-direction: row;align-items: center;height: 2.5em;">
                  <i class="fas fa-envelope" style="position: relative;inset-inline-start:15%;" />
                  <div class="ml-1" style="position: relative;inset-inline-start:15%;">{{ $t("message.Email") }}</div>
                </div>
              </template>
              <fg-input type="email" @focus="clearError()" name="email" class="no-border form-control-lg" v-validate="modelValidations.email" :placeholder="$t('message.Email')" autocapitalize="none" id="email" addon-left-icon="now-ui-icons ui-1_email-85" v-model="email" :error="getError('email')"></fg-input>
            </tab-pane>
          </tabs>
        </div>
        <div style="text-align: center">
          <span style="color: var(--color-primary)" v-show="this.error != null || this.error != undefined">{{ error }}</span>
        </div>

        <div slot="footer">
          <div v-if="!IS_OTP_LOGIN">
            <n-button type="primary" style="margin-bottom:0.5em;" nativeType="submit" round block>{{
              $t("message.Login")
              }}</n-button>
            <n-button type="primary" v-if="otpLoginEnabled" @click.native="IS_OTP_LOGIN = true" round block simple>{{
              $t("message.Login with OTP")
              }}</n-button>
            <div class="col-12 text-center mt-2">
              <a href="#" @click.prevent="showForgotPasswordModal()">{{
                $t("message.Forgot your password?")
                }}</a>

              <modal :show.sync="SHOW_FORGOT_PASSWORD_MODAL" class="modal-primary" :show-close="true" header-classes="justify-content-center" type="mini">
                <div slot="header" class="modal-profile d-flex justify-content-center align-items-center">
                  <i class="now-ui-icons users_circle-08"></i>
                </div>
                <p>{{ $t("message.Enter username to restore your password") }}</p>
                <fg-input :placeholder="$t('message.Type your username')" v-model="forgotPasswordUsername" @click.native="forgotPasswordErrorMessage = ''"></fg-input>
                <div class="col-12 text-center p-0">
                  <span style="font-size: smaller">{{
                    forgotPasswordErrorMessage
                    }}</span>
                </div>
                <template slot="footer">
                  <n-button type="neutral" link></n-button>
                  <n-button type="neutral" link @click.native="askForPasswordReset()">{{ $t("message.Submit") }}</n-button>
                </template>
              </modal>
            </div>
          </div>

          <div v-if="IS_OTP_LOGIN">
            <n-button type="primary" @click.native="getOtp()" round block>{{
              $t("message.Get OTP")
              }}</n-button>
            <div class="col-12 text-right mt-2">
              <a style="color:#fff;" @click.prevent="IS_OTP_LOGIN = false">{{
                $t("message.Login with password")
                }}</a>
            </div>
            <otp-modal :identifier="identifier" ref="otpModal" @otp-success="onOtpSuccess" @otp-error="onOtpError"></otp-modal>

          </div>
        </div>
      </card>
      <div class="row">
        <div class="col-12">
          <div v-if="brandLogoUrl && !appSettings.whiteLabelled" style="text-align: center;">
            <p style="color: white; margin-top: 1em; margin-bottom: 0em;">Powered by</p>
            <img style="width:11em; margin-bottom:2em;" class="logo-img" src="@/assets/img/teslon-carenation-sm.png" alt />
          </div>
          <div style="color:white; padding-right: 1.25rem; padding-left: 1.25rem; text-align: center;">
            {{ $t("message.By signing in, you agree to our ") }}<a href="#" @click.prevent="goToTermsOfUse()">{{ $t("message.Terms of Use") }}</a> {{ $t("message.and ") }}<a href="#" @click.prevent="goToPrivacyPolicy()">{{ $t("message.Privacy Policy") }}.</a>
          </div>

        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Modal from ".././components/Modal";
import socket from "@/services/socket";
import offline from "@/services/offline";
import { TabPane, Tabs } from "src/components";

export default {
  components: {
    Modal,
    TabPane,
    Tabs,
  },

  data() {
    return {
      username: "",
      password: "",
      _user: {},
      Authentication: {},
      localStorage: {},
      error: "",
      fullPage: false,
      SHOW_FORGOT_PASSWORD_MODAL: false,
      forgotPasswordUsername: null,
      forgotPasswordErrorMessage: "",
      brandLogoUrl: null,
      responseStatusCode: null,
      IS_OTP_LOGIN: false,
      identifier: null,
      mobileNumber: null,
      email: null,
      isValidMobile: false,
      activeOtpTab: "mobile",
      modelValidations: {
        email: {
          required: true,
          email: true,
        },
      },
      tenantName: "",
    };
  },

  computed: {
    settings() {
      return this.$store.state.settings;
    },
    webexEmbeddedConfig() {
      return this.$store.state.webexEmbeddedConfig;
    },
    otpLoginEnabled() {
      return (
        this.settings.otpLogin.providerApp.enabled &&
        (this.settings.smsAPI.enabled || this.settings.emailAPI.enabled)
      );
    },
  },

  methods: {
    setActiveTab(activeTab) {
      this.activeOtpTab = activeTab;
    },
    mobileNumberUpdate(payload) {
      this.clearError();
      this.isValidMobile = payload.isValid;
      this.identifier = payload.formattedNumber;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getOtp() {
      if(this.activeOtpTab == "email") {
        this.identifier = this.email;
      }
      if(this.identifier) {
        this.$refs.otpModal.getOtp(this.identifier);
      }
    },
    onOtpSuccess(response) {
      this.error = "";
      let that = this;
      this.$store.commit("setState", {
        stateName: "SHOW_OTP_MODAL",
        stateValue: false,
      });

      swal
        .fire({
          type: "success",
          title: this.$t("message.OTP validated successfully"),
          timer: 2000,
        })
        .then(that.signinCallback(response));
    },
    async signinCallback(response) {
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      try {
        socket.connect(response);
        offline.activate(this.baseUrl);

        if(
          response &&
          (response.roles.includes("doctor") ||
            response.roles.includes("nurse") ||
            response.roles.includes("careCoordinator") ||
            response.roles.includes("lab-operator") ||
            response.roles.includes("lab-runner") ||
            response.roles.includes("patient"))
        ) {
          this.Authentication.user = response;
          localStorage.user = JSON.stringify(this.Authentication.user);

          await this.$store.dispatch("getSettings");

          if(
            this.Authentication.user.endpoint &&
            this.Authentication.user.endpoint.videoConfEPType ==
            "SPARK_EMBEDDED"
          ) {
            this.initiateWebexOAuth();
          } else if(
            this.Authentication.user.endpoint &&
            this.Authentication.user.endpoint.videoConfEPType ==
            "WEBEXTEAMS_GUEST"
          ) {
            this.initiateWebexGuestAccess();
          } else {
            if(response.roles.includes("doctor")) {
              this.$router.push({ path: "/home" });
            } else if(response.roles.includes("nurse")) {
              this.$router.push({ path: "/nursehome" });
            } else if(response.roles.includes("careCoordinator")) {
              this.$router.push({ path: "/carecohome" });
            } else if(response.roles.includes("lab-operator")) {
              this.$router.push({ path: "/laboperatorhome" });
            } else if(response.roles.includes("lab-runner")) {
              this.$router.push({ path: "/labrunnerhome" });
            } else if(response.roles.includes("patient")) {
              this.$router.push({ path: "/patienthome" });
            } else if(response.roles.includes("ambulance-driver")) {
              this.$router.push({ path: "/ambulancedriverhome" });
            }
          }
        } else {
          this.error = this.$t("message.Invalid User");
          loader.hide();
        }
      } catch(err) {
        console.log(err);
        loader.hide();
      }
    },
    onOtpError() {
      this.error = this.$t("message.Unable to send OTPPlease enter the correct details");
      setTimeout(() => {
        this.error = "";
      }, 2000);
    },
    goToPrivacyPolicy() {
      this.$router.push("/privacypolicy");
    },
    goToTermsOfUse() {
      this.$router.push("/termsofuse");
    },
    async signin() {
      this._user = {
        username: this.username,
        password: this.password,
      };
      if(this.password != "") {
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel,
        });

        let result = null;

        try {
          result = await this.$store.dispatch("signin", this._user);
          if(result && result.shouldChangePassword == true) {
            try {
              let options = {
                userId: result._id,
              };
              if(localStorage.firebaseToken) {
                options["deviceToken"] = localStorage.firebaseToken;
              }
              await this.$store.dispatch("signout", options);
              let shouldChangePasswordUser = {
                userId: result._id,
                password: this._user.password,
                tenantName: this.tenantName,
              };
              await this.$store.commit("setState", {
                stateName: "shouldChangePasswordUser",
                stateValue: shouldChangePasswordUser,
              });
              this.$router.push("shouldchangepassword");
              return;
            } catch(e) {
              console.log(e);
              return;
            }
          }
          socket.connect(result);
          offline.activate(this.baseUrl);
        } catch(e) {
          console.log(e);
          if(e.response && e.response.status && e.response.status == 400) {
            this.responseStatusCode = 400;
            if(
              e.response.data &&
              e.response.data.message == "Tenant is disabled"
            ) {
              swal.fire({
                title: this.$t("message.Tenant is disabled"),
                text: this.$t("message.Please contact administrator"),
                timer: 4000,
                type: "info",
              });
              this.error = this.$t("message.Tenant is disabled");
            } else {
              this.error = this.$t("message.Invalid Username or Password");
            }
          } else {
            this.error = this.$t("message.Invalid Server Url");
          }
          loader.hide();
        }

        if(
          result &&
          (result.roles.includes("doctor") ||
            result.roles.includes("nurse") ||
            result.roles.includes("careCoordinator") ||
            result.roles.includes("lab-operator") ||
            result.roles.includes("lab-runner") ||
            result.roles.includes("patient") ||
            result.roles.includes("ambulance-driver"))
        ) {
          this.Authentication.user = result;
          localStorage.user = JSON.stringify(this.Authentication.user);
          this.$store.commit('setState', {
            stateName: 'currentUser',
            stateValue: this.Authentication.user
          })
          await this.$store.dispatch("getSettings");

          if(
            this.Authentication.user.endpoint &&
            this.Authentication.user.endpoint.videoConfEPType ==
            "SPARK_EMBEDDED"
          ) {
            this.initiateWebexOAuth();
          } else if(
            this.Authentication.user.endpoint &&
            this.Authentication.user.endpoint.videoConfEPType ==
            "WEBEXTEAMS_GUEST"
          ) {
            this.initiateWebexGuestAccess();
          } else {
            if(result.roles.includes("doctor")) {
              this.$router.push({ path: "/home" });
            } else if(result.roles.includes("nurse")) {
              this.$router.push({ path: "/nursehome" });
            } else if(result.roles.includes("careCoordinator")) {
              this.$router.push({ path: "/carecohome" });
            } else if(result.roles.includes("lab-operator")) {
              this.$router.push({ path: "/laboperatorhome" });
            } else if(result.roles.includes("lab-runner")) {
              this.$router.push({ path: "/labrunnerhome" });
            } else if(result.roles.includes("patient")) {
              this.$router.push({ path: "/patienthome" });
            } else if(result.roles.includes("ambulance-driver")) {
              this.$router.push({ path: "/ambulancedriverhome" });
            }
          }
        } else {
          if(!this.error) {
            if(this.responseStatusCode == 400) {
              this.error = this.$t("message.Invalid Username or Password");
            } else {
              this.error = this.$t("message.Invalid Server Url");
            }
          }
          loader.hide();
        }
      }
    },
    clearError() {
      this.error = "";
    },
    selectLanguage(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
    },
    showForgotPasswordModal() {
      this.SHOW_FORGOT_PASSWORD_MODAL = true;
    },
    async askForPasswordReset() {
      try {
        let response = await this.$store.dispatch("resetPassword", {
          username: this.forgotPasswordUsername,
        });
        this.SHOW_FORGOT_PASSWORD_MODAL = false;
        this.forgotPasswordUsername = "";
        swal.fire({
          text: response.message,
          timer: 3000,
          type: "success",
        });
      } catch(e) {
        this.forgotPasswordErrorMessage = e.message;
      }
    },
    isSupportedLanguage(code) {
      if(
        this.settings &&
        this.settings.supportedLanguages &&
        this.settings.supportedLanguages.length > 0
      ) {
        let language = this.settings.supportedLanguages.find((lang) => {
          return lang.code == code;
        });

        if(language) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    //Spark Embedded methods
    initiateWebexOAuth() {
      if(this.settings && this.settings.ciscoSparkSettings.clientId) {
        var queryParams = {
          client_id: this.settings.ciscoSparkSettings.clientId,
          response_type: "code",
          redirect_uri: encodeURIComponent(
            this.webexEmbeddedConfig.redirectUri
          ),
          scope: encodeURIComponent("spark:all spark:kms"),
          state: "asd123",
        };
        var oAuthUrl = this.webexEmbeddedConfig.webexOAuth2BaseUrl + "?";
        Object.keys(queryParams).forEach((queryParamKey) => {
          oAuthUrl =
            oAuthUrl + queryParamKey + "=" + queryParams[queryParamKey] + "&";
        });
        oAuthUrl = oAuthUrl.substring(0, oAuthUrl.length - 1);
        var target = "_blank";
        var options = "location=no,hidden=yes";

        this.webexEmbeddedConfig.inAppBrowserRef = cordova.InAppBrowser.open(
          oAuthUrl,
          target,
          options
        );

        this.webexEmbeddedConfig.inAppBrowserRef.addEventListener(
          "loadstart",
          this.loadWebexStartCallBack.bind(this)
        );

        this.webexEmbeddedConfig.inAppBrowserRef.addEventListener(
          "loadstop",
          this.loadWebexStopCallBack.bind(this)
        );

        this.webexEmbeddedConfig.inAppBrowserRef.addEventListener(
          "loaderror",
          this.loadWebexErrorCallBack.bind(this)
        );
      }
    },
    async initiateWebexGuestAccess() {
      let response = await this.$store.dispatch("getWebexGuestAccess");

      if(response) {
        if(this.Authentication.user.roles.indexOf("doctor") > -1) {
          this.$router.push({ path: "/home" });
        } else if(this.Authentication.user.roles.indexOf("nurse") > -1) {
          this.$router.push({ path: "/nursehome" });
        } else if(this.Authentication.user.roles.indexOf("patient") > -1) {
          this.$router.push({ path: "/patienthome" });
        }
      }
    },
    loadWebexStartCallBack(evt) {
      console.log("loadStartCallBack - " + evt.url);
    },
    async loadWebexStopCallBack(evt) {
      console.log("loadStopCallBack - " + evt.url);
      if(this.webexEmbeddedConfig.inAppBrowserRef) {
        if(evt.url.indexOf(this.webexEmbeddedConfig.redirectUri) == 0) {
          this.webexEmbeddedConfig.inAppBrowserRef.close();

          await this.$store.dispatch("getWebexAccessToken", {
            code: this.getParameterByName("code", evt.url),
            redirectUri: this.webexEmbeddedConfig.redirectUri,
          });

          if(this.user.roles.indexOf("doctor") > -1) {
            this.$router.push({ path: "/home" });
          } else if(this.user.roles.indexOf("nurse") > -1) {
            this.$router.push({ path: "/nursehome" });
          }
        } else if(
          evt.url.indexOf(this.webexEmbeddedConfig.webexIdBrokerUri1) == 0
        ) {
          this.webexEmbeddedConfig.inAppBrowserRef.show();

          this.webexEmbeddedConfig.inAppBrowserRef.executeScript({
            code:
              "\
                            var emailInput = document.querySelector('#IDToken1');\
                            var nextButton = document.querySelector('#IDButton2');\
                            if (emailInput) {\
                                emailInput.value = '" +
              this.Authentication.user.endpoint.videoConfDetails.username +
              "';\
                            }\
                            if (nextButton) {\
                                nextButton.click();\
                            }",
          });
        } else if(
          evt.url.indexOf(this.webexEmbeddedConfig.webexIdBrokerUri2) == 0
        ) {
          this.webexEmbeddedConfig.inAppBrowserRef.show();

          this.webexEmbeddedConfig.inAppBrowserRef.executeScript({
            code:
              "\
                            var emailInput = document.querySelector('#IDToken2');\
                            var nextButton = document.querySelector('#Button1');\
                            if (emailInput) {\
                                emailInput.value = '" +
              this.Authentication.user.endpoint.videoConfDetails.password +
              "';\
                            }\
                            if (nextButton) {\
                                nextButton.click();\
                            }",
          });
        } else if(
          evt.url.indexOf(this.webexEmbeddedConfig.webexIdBrokerUri3) == 0
        ) {
          this.webexEmbeddedConfig.inAppBrowserRef.show();

          this.webexEmbeddedConfig.inAppBrowserRef.executeScript({
            code: "\
                            var acceptButton = document.querySelector('.cui-button.cui-button--blue');\
                            if (acceptButton) {\
                                acceptButton.click();\
                            }",
          });
        }
      }
    },
    loadWebexErrorCallBack(err) {
      console.log(err);
      this.webexEmbeddedConfig.inAppBrowserRef.close();
      this.webexEmbeddedConfig.inAppBrowserRef = null;
    },
    getParameterByName(name, url) {
      if(!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if(!results) return null;
      if(!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
  },
  async beforeMount() {
    try {
      let tenant = await this.$store.dispatch("getTenantName");
      this.tenantName = tenant;
      await this.$store.dispatch("getPublicSettings", tenant);
      if(this.settings.brandLogo) {
        this.brandLogoUrl = await this.$store.dispatch("getBrandLogo", tenant);
      }
      if(this.settings.appBackground) {
        await this.$store.dispatch("getAppBackground", tenant);
        await this.$store.dispatch("getBrandLogoMini", tenant);
      }
    } catch(e) {
      console.log(e);
    }
  },

  async mounted() {
    if(localStorage.user) {
      this.Authentication.user = JSON.parse(localStorage.user);
      if(this.Authentication.user != undefined) {
        this.$store.state.activeUser = this.Authentication.user;
        if(this.Authentication.user.roles.indexOf("doctor") > -1) {
          this.$router.push({ path: "/home" });
        } else if(this.Authentication.user.roles.indexOf("nurse") > -1) {
          this.$router.push({ path: "/nursehome" });
        } else if(
          this.Authentication.user.roles.indexOf("careCoordinator") > -1
        ) {
          this.$router.push({ path: "/carecohome" });
        } else if(this.Authentication.user.roles.indexOf("patient") > -1) {
          this.$router.push({ path: "/patienthome" });
        }
      } else {
        this.Authentication.user = null;
      }
    } else {
      this.Authentication.user = null;
    }

    this.$root.onBackButton = () => {
      swal
        .fire({
          title: this.$t("message.Are you sure?"),
          confirmButtonText: this.$t("message.Exit"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.Stay"),
        })
        .then(async (result) => {
          if(result && result.value) {
            navigator.app.exitApp();
          }
        });
    };
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.section-image .nav-pills .nav-link {
  background-color: hsla(0, 0%, 87.1%, 0.3);
}

.nav-pills .nav-item .nav-link {
  padding: 0;
}

.logo-img {
  max-width: 500px;
}
</style>
<style scoped>
.dropdown.dropdown {
  display: inline-block;
}

/deep/ul.nav.nav-pills {
  justify-content: space-between;
}

/deep/input::placeholder {
  color: #fff !important;
}

/deep/#MazPhoneNumberInput input.country-selector__input {
  color: #fff !important;
}

/deep/.tab-space {
  padding-bottom: 0;
}

/deep/.input-tel__label {
  display: none;
}

/deep/ .nav-link {
  color: #fff !important;
  padding-top: 0;
}

a.dropdown-toggle.nav-link {
  padding-left: 0.5em !important;
}

.logo-container {
  height: 4em;
}

.brand-logo {
  max-height: 5em;
  width: auto !important;
}

.setting-icon,
.language-selection {
  top: 1.5em;
}

.ios .setting-icon,
.ios .language-selection {
  top: 3em;
}
</style>

<style scope>
.modal.modal-mini .modal-footer button:first-child {
  opacity: 1;
}
</style>
<style scoped>
/deep/ .dropdown .dropdown-toggle {
  color: #fff;
}
</style>
